(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gg-welcome-popup"]) return;
  try {
    
  if (!customElements.get('gg-welcome-popup')) {
    class GoodGramWelcomePopup extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
        this.abortController = new AbortController();
        const signal = this.abortController.signal;
        this.isEditor = this.dataset.editor === 'true';
        this.storageKey = 'gg-welcome-until-v1';
        this.pendingKey = 'gg-welcome-pending-v1';
        this.result = this.querySelector('[data-result]')?.dataset.result;
        this.querySelectorAll('[data-dismiss]').forEach(button => button.addEventListener('click', () => this.dismiss(), { signal }));
        this.dialog.addEventListener('cancel', event => { event.preventDefault(); this.dismiss(); }, { signal });
        this.dialog.addEventListener('click', event => {
          const rect = this.dialog.getBoundingClientRect();
          if (event.target === this.dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) this.dismiss();
        }, { signal });
        this.dialog.addEventListener('close', () => this.unlockScroll(), { signal });
        document.addEventListener('submit', event => {
          const form = event.target;
          if (form.id === 'GoodGramWelcome') {
            if (this.isEditor) { event.preventDefault(); return; }
            this.writeStorage('sessionStorage', this.pendingKey, Date.now());
          } else if (form.querySelector('input[name="form_type"][value="customer"]')) {
            this.writeStorage('sessionStorage', this.pendingKey, 0);
          }
        }, { signal });
        document.addEventListener('shopify:section:select', event => {
          if (this.isEditor && event.target.contains(this)) this.open();
        }, { signal });
        const submittedHere = Date.now() - this.readStorage('sessionStorage', this.pendingKey) < 3600000 || location.hash === '#GoodGramWelcome';
        if (this.result === 'success') {
          if (!this.isEditor) this.writeStorage('localStorage', this.storageKey, Date.now() + 365 * 86400000);
          if (submittedHere) { this.writeStorage('sessionStorage', this.pendingKey, 0); this.open(); }
          return;
        }
        if (this.result === 'error' && submittedHere) { this.open(); return; }
        if (this.isEditor) { if (this.dataset.editorPreview === 'true') this.open(); return; }
        if (this.dataset.subscribed === 'true' || /^(cart|customers\/|password|challenge)/.test(this.dataset.pageType) || /\/(account|challenge)(\/|$)/.test(location.pathname)) return;
        if (this.readStorage('localStorage', this.storageKey) > Date.now() || this.readStorage('sessionStorage', 'gg-welcome-seen-v1')) return;
        this.timer = setTimeout(() => this.openWhenReady(), Number(this.dataset.delay) * 1000);
      }
      readStorage(type, key) { try { return Number(window[type].getItem(key)) || 0; } catch { return 0; } }
      writeStorage(type, key, value) { try { window[type].setItem(key, String(value)); } catch {} }
      openWhenReady() {
        if (!this.isConnected) return;
        if (document.hidden || document.querySelector('dialog[open]') || document.activeElement?.matches('input, textarea, select, [contenteditable="true"]')) {
          this.timer = setTimeout(() => this.openWhenReady(), 1500);
          return;
        }
        this.open();
      }
      open() {
        if (this.dialog.open) return;
        this.previousFocus = document.activeElement;
        this.scrollPosition = window.scrollY;
        this.previousBodyStyles = { position: document.body.style.position, top: document.body.style.top, width: document.body.style.width, overflow: document.body.style.overflow };
        this.dialog.showModal();
        document.body.style.position = 'fixed';
        document.body.style.top = `-${this.scrollPosition}px`;
        document.body.style.width = '100%';
        document.body.style.overflow = 'hidden';
        if (!this.isEditor) this.writeStorage('sessionStorage', 'gg-welcome-seen-v1', 1);
      }
      dismiss() {
        if (!this.isEditor) {
          const days = this.result === 'success' ? 365 : Number(this.dataset.repeatDays);
          this.writeStorage('localStorage', this.storageKey, Date.now() + days * 86400000);
        }
        this.dialog.close();
        this.unlockScroll();
        if (this.previousFocus?.isConnected && typeof this.previousFocus.focus === 'function') this.previousFocus.focus({ preventScroll: true });
      }
      unlockScroll() {
        if (!this.previousBodyStyles) return;
        Object.assign(document.body.style, this.previousBodyStyles);
        window.scrollTo({ top: this.scrollPosition, behavior: 'instant' });
        this.previousBodyStyles = null;
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        this.abortController?.abort();
        if (this.dialog?.open) this.dialog.close();
        this.unlockScroll();
      }
    }
    customElements.define('gg-welcome-popup', GoodGramWelcomePopup);
  }

  } catch(e) { console.error(e); }
})();
})();
